import {useState} from "react";
import Modal from "../../../shared/component/Modal/Modal";
import T from "../../../shared/component/t/T";
import snippets from "../../../helpers/snippets";

const AiComponent_Image = ({
	                           maxSize = 1,
	                           img = [],
	                           update = () => {
	                           }
                           }) => {
	
	const [images] = useState(img.img)
	const [selected, setSelected] = useState(img.selected)
	const [hovered, setHovered] = useState({})
	const [modal, setModal] = useState({
		show: false,
	})
	const wholeImagesSTYLE = {
		overflow: 'auto',
		maxHeight: '30dvh'
	}
	const hoveredSTYLE = {
		maxHeight: '30dvh'
	}
	const selectedSTYLE = {
		maxHeight: '25dvh'
	}
	
	
	
	const removeImage = (item) => {
		const tmp = selected.filter(it => it.imgSeriesFileLink !== item.imgSeriesFileLink)
		setSelected(tmp)
		update(tmp)
	}
	
	const addImage = (item) => {
		const exists = selected.some(it => it.imgSeriesFileLink === item.imgSeriesFileLink)
		if (selected.length < maxSize && !exists) {
			const tmp = [...selected, item]
			update(tmp)
			setSelected(tmp)
		} else
			console.warn(`max size of selected reached:  ${maxSize} or this image already exists`)
	}
	
	const showModal = () => {
		setModal(prevState => ({...prevState, show: true}))
	}
	
	const closeModal = () => {
		setModal(prevState => ({...prevState, show: false}))
	}
	
	const plusSign = () => {
		return <button key={snippets.randomKey()} onClick={showModal} className={'mx-2 bg-transparent text-white rounded-2'}
		               style={{width: '64px', height: '64px', cursor: 'pointer', border: '1px solid white'}}>+</button>
	}
	
	const Handler = () => {
		let res = []
		if (selected.length) {
			res = selected.map((item, index) => (
				<ImageComponent url={`${item.imgSeriesFileLink}?width=64`}
				                close={() => removeImage(item)}
				                className={'p-0 mx-3'}
				                key={index}
				/>
			))
		}
		if (selected.length - maxSize < 0)
			res = [...res, plusSign()]
		return res
	}
	
	const wholeImagesDIV = () => {
		return images.map((item, index) => {
			const sel = selected.some(it => it.imgSeriesFileLink === item.imgSeriesFileLink)
			return <img className={`mx-2 my-1 ${sel ? 'opacity-25' : ''}`}
			            key={index}
			            alt=''
			            src={`${item.imgSeriesFileLink}?width=64`}
			            loading={'lazy'}
			            onClick={() => addImage(item)}
			            onDoubleClick={() => removeImage(item)}
			            onMouseOver={() => hoveredIn(item)}
			            onMouseLeave={() => hoveredOut()}
			/>
		})
	}
	
	const hoveredIn = (item) => {
		setHovered(item)
	}
	const hoveredOut = () => {
		setHovered({})
	}
	const hoveredDIV = () => {
		return <img alt='' src={hovered.imgSeriesFileLink} style={{maxWidth: "90%", maxHeight: "90%"}}/>
	}
	
	const selectedDIV = () => {
		return selected.map((item, index) =>
			<ImageComponent url={`${item.imgSeriesFileLink}?width=64`}
			                close={() => removeImage(item)}
			                className={`col-2 p-0 mx-4 mt-5`}
			                key={index}
			/>)
	}
	
	const body = () => {
		return <div className={'container'}>
			<div className={'row'}>
				<div className={'col-8'} style={{...wholeImagesSTYLE}}>
					<T token={'total_pictures'}/>
					<div >{wholeImagesDIV()}</div>
				</div>
				<div className={'col-4'} style={{...hoveredSTYLE}}>
					<T token={'preview_picture'}/>
					<div className={'col-10'} >{hoveredDIV()}</div>
				</div>
			</div>
			
			<div className={'d-flex flex-row align-items-center'} style={{...selectedSTYLE}}>
				<span className={''}>
					<T token={'selected_pictures'}/> :
				</span>
				<div className={'row'} >{selectedDIV()}</div>
			</div>
		</div>
	}
	
	const footer = () => {
		return <>
			<div className={'imodal__action'}>
				<div className={'imodal__btn imodal__btn--secondary'}
				     onClick={closeModal}><T token={'close'}/>
				</div>
			</div>
		</>
	}
	
	
	return <>
		{Handler()}
		{modal.show && <Modal className="spell_check_modal"
		                      title="select_pictures"
		                      closeModal={closeModal}
		                      footer={footer()}
		>
			<div className={'imodal spell_check'}>
				<div className={'imodal__body spell_check_body'}>
					{body()}
				</div>
			</div>
		</Modal>}
	</>
}

const ImageComponent = ({
	                        url,
	                        close = () => {},
	                        className = '',
	                        ...config
                        }) => {
	return <div className={className} style={{position: 'relative', width: '64px', height: '64px'}}>
		<img alt=''
		     src={url}
		     onDoubleClick={() => close()}
		     {...config}
		/>
		<i className="fal fa-times-circle"
		   style={{cursor: 'pointer', position: 'absolute', top: 0, left: 0}}
		   onClick={() => close()}/>
	</div>
}

export default AiComponent_Image;